import { Box, Flex, Text } from '@mantine/core';
import React from 'react';

type TabHeaderProps = {
  title: string;
  subtitle: React.ReactNode;
  children?: React.ReactNode;
};

export default function TabHeader({ title, subtitle, children }: TabHeaderProps) {
  return (
    <Flex justify="space-between" align="flex-start" mb="sm">
      <Box>
        <Text size="xl" fw={500}>
          {title}
        </Text>
        <Text size="sm" c="dimmed" mt={2}>
          {subtitle}
        </Text>
      </Box>

      {children && <Box>{children}</Box>}
    </Flex>
  );
}
